import { TIMELINE_TRACK_HEIGHT } from '../../constants/global';
import { Kind } from '../../types/schemas/calendar';
import { styled } from '../stitches.config'

/* The header contains week information: the number and date range */
export const Header = styled('div', {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: '0.75rem',
  borderRadius: '0.5rem',

  backgroundColor: '$elementBackground',
  variants: {
    active: {
      true: {
        color: '$primary11',
        fontWeight: 600,
      },
    },
  },
})

export const Day = styled('div', {
  flex: 1, 
  // width: '7rem',
  // height: '$navHeight',
  backgroundColor: 'transparent',
  textAlign: 'center',
  variants: {
    active: {
      true: {
        color: '$primary11',
        fontWeight: 600,
      },
    },
  },
})




export const TRACK_HEIGHT_NUM = parseFloat(TIMELINE_TRACK_HEIGHT);

export const Stage = styled('div', {
  position: 'relative',
  height: `calc(24 * ${TIMELINE_TRACK_HEIGHT})`,
});

export const Block = styled('div', {
  position: 'absolute',
  padding: '0.1rem 0.2rem',
  fontSize: '0.75rem',
  color: '$sand1',
  borderRadius: 3,
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis',
  transition: 'filter 120ms ease',
  '&:hover': { filter: 'brightness(.85)' },
});

export const BRAND_STYLES: Record<Kind, { border?: string; fill: string; opacity?: number }> = {
  LESSON: { border: '$blue9', fill: '$blue7' },
  FREE:   { fill: '$green9', opacity: 0.2 },
  INTRO:  { border: '$yellow5', fill: '$yellow6' },
};